<template>
  <div class="album-listing">
    <h2>{{ album.title }}</h2>
    <ol class="mx-3">
      <li
        v-for="song in album.songs"
        :key="song.title"
        :class="{ active: isCurrentSong(song) }"
        class="px-3"
        @click="selectSong(song)"
      >
        {{ song.title || song.path.slice(-1)[0] }}
        <span class="float-right">{{ formatDuration(song.duration) }}</span>
      </li>
    </ol>
  </div>
</template>

<script lang="ts">
import { reactive, toRefs, toRaw, Ref } from 'vue';
import { AlbumEntry, SongEntry } from '../store/MusicStore';
import { currentlyPlayingStore } from '@/store';

export default {
  setup(props) {
    return {
      ...useSongSelector(props),
      formatDuration(duration: number) {
        if (duration > 3600) {
          const hours = Math.floor(duration / 3600);
          duration %= 3600;
          const minutes = Math.floor(duration / 60).toString().padStart(2, '0');
          const seconds = Math.floor(duration % 60).toString().padStart(2, '0');
          return `${hours}:${minutes}:${seconds}`;
        } else {
          const minutes = Math.floor(duration / 60);
          const seconds = Math.floor(duration % 60).toString().padStart(2, '0');
          return `${minutes}:${seconds}`;
        }
      }
    };
  },
  props: {
    album: {
      type: Object as () => AlbumEntry,
      required: true
    }
  }
};

function useSongSelector(props: { album: AlbumEntry }) {
  const state = reactive({
    currentSong: null as SongEntry
  });

  function selectSong(song: SongEntry) {
    console.log('Selected', song);
    state.currentSong = song;
    currentlyPlayingStore.setQueue(props.album.songs);
    currentlyPlayingStore.selectSong(song);
  }

  function isCurrentSong(song: SongEntry) {
    return toRaw(song) === toRaw(state.currentSong);
  }

  return {
    ...toRefs(state),
    isCurrentSong,
    selectSong
  };
}

</script>

<style lang="scss" scoped>
$borderColor: #eee;

.album-listing {
  background-color: orangered;
}

ol {
  column-width: 32rem;
  column-count: auto;
  padding: 1px;
  list-style-position: inside;

  li {
    cursor: pointer;

    border-top: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    margin-bottom: -1px;
    margin-top: -1px;

    &.active {
      background-color: cyan;
    }
  }
}
</style>
